import { useApiRequest } from '@/lib/http-utils'
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'
import { turnStatusKeyFactory } from './use-turn-status-query'

type PauseJourneyApiResponse = {
  content: string
  live_session_view: string | null
  recording_url: string | null
  message_type: string
  journey_view_reference: string | null
}
export function usePauseJourneyMutation(
  { workflowId, turnId }: { workflowId: string; turnId: string },
  options: UseMutationOptions<PauseJourneyApiResponse, Error, string> = {},
) {
  const queryClient = useQueryClient()
  const { apiRequest, domainId } = useApiRequest()
  const turnQueryKey = turnStatusKeyFactory({ workflowId, turnId, domainId })
  return useMutation({
    mutationKey: ['pause-journey'],
    mutationFn: async (journeyViewReference: string) => {
      const response = await apiRequest({
        path: taskManagerApiPaths.pauseJourney({ journeyViewReference }),
        options: {
          method: 'POST',
          body: JSON.stringify({ workflow_id: workflowId }),
        },
      })

      if (!response.ok) throw new Error('FAILED_TO_PAUSE_JOURNEY')

      const data = (await response.json()) as PauseJourneyApiResponse

      return data
    },
    onSettled: async (data, error, variables, result, context) => {
      await queryClient.cancelQueries({ queryKey: turnQueryKey })
      await queryClient.invalidateQueries({ queryKey: turnQueryKey })
      if (options.onSettled) {
        await options.onSettled(data, error, variables, result, context)
      }
    },
    ...options,
  })
}
